<div mat-dialog-content>

  <h2>出金依頼に依らない独立した送金処理管理データを作成します</h2>

  <div style="margin-top: 1em; margin-bottom: 1em;">
    <h4>①出資者を選択してください</h4>
    <br>
    <div style="">
      <app-search-user-list [isDialogMode]="true" (selected)="onUserSelect($event)"></app-search-user-list>
    </div>
  </div>

  <div *ngIf="user">
    <h4>②対象の口座を選択してください（クローズ済みの口座については、残高が０になった月のデータを表示しています）</h4>

      <ag-grid-angular
        #grid
        class="ag-theme-alpine compact-grid"
        style="width: 100%; height: 300px;"
        [rowData]="reports"
        [localeText]="localeText"
        [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs"
        [rowSelection]="'multiple'"
        [suppressRowClickSelection]="true"
        (rowSelected)="onRowSelected()"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
  </div>

  <div *ngIf="capIds.length > 0">
    <h4>③管理表に記載してある出金情報を入力してください（出金依頼とほぼ同じ書式です）</h4>

    <table style="font-size: 14px;" class="info">
      <tr>
        <th style="width: 200px;">出資口座番号</th>
        <td style="font-size: 15px;">{{capIds.join(', ')}}</td>
      </tr>
      <tr>
        <th>出金の確定した日</th>
        <td><input type="date" [(ngModel)]="created_at"></td>
      </tr>
      <tr>
        <th>出金方法</th>
        <td>
          <mat-radio-group [(ngModel)]="method">
            <mat-radio-button class="block" value="全額出金">全額出金（解約）</mat-radio-button>
            <mat-radio-button class="block" value="一部出金">一部出金（残額は運用継続）</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
      <tr>
        <th>通貨</th>
        <td>
          <select [(ngModel)]="currency">
            <option *ngFor="let currency of Currencies" [value]="currency">{{currency}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <th>最終確定した出金額</th>
        <td><app-decimal-input [(ngModel)]="amount" [positiveOnly]="true"></app-decimal-input>（②の金額と違う場合は管理表の金額を優先）</td>
      </tr>
      <tr>
        <th>送金先銀行名</th>
        <td><input type="text" [(ngModel)]="bank_name" style="width: 98%;"></td>
      </tr>
      <tr>
        <th>本店・支店名</th>
        <td><input type="text" [(ngModel)]="bank_branch" style="width: 98%;"></td>
      </tr>
      <tr>
        <th>本店・支店名番号</th>
        <td><input type="text" [(ngModel)]="branch_number"></td>
      </tr>
      <tr>
        <th>口座種別</th>
        <td>
          <mat-radio-group [(ngModel)]="acc_type">
            <mat-radio-button class="block" value="普通預金">普通預金</mat-radio-button>
            <mat-radio-button class="block" value="当座預金">当座預金</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
      <tr>
        <th>口座番号</th>
        <td><input type="text" [(ngModel)]="acc_number"></td>
      </tr>
      <tr>
        <th>口座名義種別</th>
        <td>
          <mat-radio-group [(ngModel)]="holder_type">
            <mat-radio-button class="block" value="ご契約者様名と同じ">ご契約者様名と同じ</mat-radio-button>
            <mat-radio-button class="block" value="共同名義の方の口座">共同名義の方の口座</mat-radio-button>
            <mat-radio-button class="block" value="法人口座">法人口座</mat-radio-button>
          </mat-radio-group>
        </td>
      </tr>
      <tr>
        <th>海外銀行の場合</th>
        <td><textarea [(ngModel)]="overseas" rows="3" style="width: 98%;"></textarea></td>
      </tr>
      <tr>
        <th>補足</th>
        <td><textarea [(ngModel)]="body" rows="6" style="width: 98%;"></textarea></td>
      </tr>

    </table>



  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="saving">
      キャンセル
    </button>
    <button mat-raised-button color="primary"
            (click)="onSave()"
            [disabled]="saving || !isValid">
      {{ saving ? '保存中...' : '保存' }}
    </button>

</div>
